import { useNavigate } from 'react-router-dom';
import './StartPage.css';

const StartPage = () => {
  const navigate = useNavigate();  

  return (
    <div className="start-bg">
      <div className="start-title"></div>
      <button className="start-btn" onClick={() => navigate('/fork')}>Start</button>
    </div>
  );
};

export default StartPage;